function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M37.0647 38.2457C40.4263 38.2457 43.1515 35.5206 43.1515 32.159C43.1515 28.7974 40.4263 26.0723 37.0647 26.0723C33.7031 26.0723 30.978 28.7974 30.978 32.159C30.978 35.5206 33.7031 38.2457 37.0647 38.2457Z",
  stroke: "#4C2C89",
  strokeWidth: 2,
  strokeMiterlimit: 10
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M64.1868 51.0875C67.5484 51.0875 70.2735 48.3624 70.2735 45.0008C70.2735 41.6392 67.5484 38.9141 64.1868 38.9141C60.8252 38.9141 58.1001 41.6392 58.1001 45.0008C58.1001 48.3624 60.8252 51.0875 64.1868 51.0875Z",
  stroke: "#4C2C89",
  strokeWidth: 2,
  strokeMiterlimit: 10
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M11.5496 49.3785C14.9112 49.3785 17.6363 46.6534 17.6363 43.2918C17.6363 39.9302 14.9112 37.2051 11.5496 37.2051C8.18801 37.2051 5.46289 39.9302 5.46289 43.2918C5.46289 46.6534 8.18801 49.3785 11.5496 49.3785Z",
  stroke: "#4C2C89",
  strokeWidth: 2,
  strokeMiterlimit: 10
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M25.5229 50.9292L25.9056 45.0007C25.9056 45.0007 26.676 38.2456 32.5076 36.1895",
  stroke: "#4C2C89",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M41.6156 36.1895C41.6156 36.1895 45.6564 38.7303 46.8145 42.0415C47.9727 45.3527 50.9523 52.3017 39.6972 56.4394C39.6972 56.4394 35.4523 58.368 34.1258 55.0057C32.8044 51.6435 38.2074 50.5363 40.7993 48.2762L40.9829 45.6282",
  stroke: "#4C2C89",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M63.4115 63.6591L62.7381 64.7561C61.7993 66.2918 60.2738 67.404 58.5034 67.7561C54.8197 68.4856 51.8248 67.7407 51.8248 67.7407C51.8248 67.7407 48.7534 67.4091 48.7534 64.7918C48.7534 62.8428 50.7891 61.5928 53.3248 61.4959C55.4983 61.4142 57.3962 60.0571 58.182 58.0316C58.9371 56.0979 60.3044 53.2918 64.1819 53.8428C71.187 54.8377 72.5646 72.0469 72.5646 72.0469H61.534",
  stroke: "#4C2C89",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M10.4726 61.955L11.1461 63.052C12.0848 64.5877 13.6103 65.6999 15.3807 66.052C19.0644 66.7815 22.0593 66.0366 22.0593 66.0366C22.0593 66.0366 25.1307 65.705 25.1307 63.0877C25.1307 61.1387 23.095 59.8887 20.5593 59.7918C18.3858 59.7101 16.4879 58.353 15.7022 56.3275C14.9471 54.3938 13.5797 51.5877 9.70218 52.1387C2.6971 53.1336 1.31445 70.3377 1.31445 70.3377H12.345",
  stroke: "#4C2C89",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M47.1152 51.0879H52.1611L56.2887 60.4858",
  stroke: "#4C2C89",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M59.3343 67.5322L62.0894 73.7006L13.2222 76.0169",
  stroke: "#4C2C89",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M17.3602 66.3271L14.3296 75.9649",
  stroke: "#4C2C89",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M19.4678 59.6389L22.1565 51.0879H35.7228",
  stroke: "#4C2C89",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M67.8809 1.99609H44.6922C40.034 1.99609 36.2534 5.77159 36.2534 10.4348C36.2534 15.093 40.0289 18.8736 44.6922 18.8736H58.4115L65.6156 26.0777V18.8685H67.8758C72.5339 18.8685 76.3145 15.093 76.3145 10.4297C76.3145 5.77159 72.539 1.99609 67.8809 1.99609Z",
  stroke: "#4C2C89",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M50.6461 11.4446C51.1561 11.4446 51.5696 11.0311 51.5696 10.5211C51.5696 10.0111 51.1561 9.59766 50.6461 9.59766C50.1361 9.59766 49.7227 10.0111 49.7227 10.5211C49.7227 11.0311 50.1361 11.4446 50.6461 11.4446Z",
  fill: "#4C2C89"
});
var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M56.9015 11.4446C57.4115 11.4446 57.825 11.0311 57.825 10.5211C57.825 10.0111 57.4115 9.59766 56.9015 9.59766C56.3915 9.59766 55.978 10.0111 55.978 10.5211C55.978 11.0311 56.3915 11.4446 56.9015 11.4446Z",
  fill: "#4C2C89"
});
var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M63.2628 11.4446C63.7728 11.4446 64.1863 11.0311 64.1863 10.5211C64.1863 10.0111 63.7728 9.59766 63.2628 9.59766C62.7528 9.59766 62.3394 10.0111 62.3394 10.5211C62.3394 11.0311 62.7528 11.4446 63.2628 11.4446Z",
  fill: "#4C2C89"
});
function Svg1Franqueado(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1Franqueado);
export default __webpack_public_path__ + "static/media/1-franqueado.d678e59b641f4d7ccd03e1ef5ae9af0e.svg";
export { ForwardRef as ReactComponent };